<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.2 24.7">
    <path d="M6.7,2.9c-1.4,0.3-2.4,1.3-3,3.1C3.3,6.9,3.2,7.8,3.2,8.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.5h3.4v6.8H0V10
    c0-3.1,0.6-5.5,1.8-7.1C3,1.3,4.7,0.2,6.7,0L6.7,2.9z M17.2,2.9c-1.1,0.2-2.1,0.9-2.6,1.9c-0.6,1.2-0.9,2.5-0.9,3.8
    c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0.1,0.4h3.4v6.8h-6.7V10c0-2.3,0.5-4.6,1.6-6.6c1-1.9,3-3.2,5.1-3.4V2.9z M32.5,21.8
    c1.6-0.3,2.6-1.4,3.1-3.4c0.3-1,0.4-2.1,0.3-3.1h-3.4V8.4h6.7v6.3c0,2.3-0.5,4.6-1.5,6.6c-1,1.9-3,3.2-5.2,3.4L32.5,21.8z M22,21.8
    c1.6-0.3,2.6-1.4,3.1-3.4c0.3-1,0.4-2.1,0.3-3.1H22V8.4h6.7v6.3c0,2.3-0.5,4.6-1.5,6.6c-1,1.9-3,3.2-5.1,3.4V21.8z"/>
  </svg>
</template>
